import { InjectionToken } from '@angular/core';
import { Configuration } from '@azure/msal-browser';

export interface AzureAuthConfig {
    configuration: Configuration,
    scopes: string[]
}

export const AZURE_AUTH_CONFIG = new InjectionToken<AzureAuthConfig>('azure.auth.config');
